import React from "react";
import useTheme from "@material-ui/core/styles/useTheme";

export default ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 258.76 204.55"
    >
      <g>
        <path
          fill={color}
          d="M133.43,85.15h-3v-2.71c0-1.98-2.01-3.59-4.48-3.59H63.39v-3h62.56c4.12,0,7.48,2.96,7.48,6.59V85.15z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M161.93,175.89h-43.19c-6,0-10.88-4.88-10.88-10.88v-65.2c0-6,4.88-10.88,10.88-10.88h43.19c6,0,10.88,4.88,10.88,10.88
		v65.2C172.8,171.02,167.92,175.89,161.93,175.89z M118.74,91.94c-4.34,0-7.88,3.53-7.88,7.88v65.2c0,4.34,3.53,7.88,7.88,7.88
		h43.19c4.34,0,7.88-3.53,7.88-7.88v-65.2c0-4.34-3.53-7.88-7.88-7.88H118.74z"
        />
      </g>
      <path
        fill={color}
        d="M149.33,114.49v26h-18v-26H149.33 M150.33,111.49h-20c-1.1,0-2,0.9-2,2v28c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2v-28
	C152.33,112.39,151.44,111.49,150.33,111.49L150.33,111.49z"
      />
      <path
        fill={color}
        d="M140.33,126.38c1.66,0,3-1.34,3-3c0-1.66-1.34-3-3-3s-3,1.34-3,3C137.33,125.04,138.67,126.38,140.33,126.38z"
      />
      <path
        fill={color}
        d="M140.33,127.38c-1.84,0-3.56,0.5-5.03,1.37c-0.61,0.35-0.97,1.02-0.97,1.72v6.28h12v-6.28
	c0-0.7-0.36-1.36-0.97-1.72C143.89,127.88,142.17,127.38,140.33,127.38z"
      />
      <g>
        <path
          fill={color}
          d="M92.27,91.68v26h-18v-26H92.27 M93.27,88.68h-20c-1.1,0-2,0.9-2,2v28c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2v-28
		C95.27,89.58,94.38,88.68,93.27,88.68L93.27,88.68z"
        />
        <path
          fill={color}
          d="M83.27,103.57c1.66,0,3-1.34,3-3c0-1.66-1.34-3-3-3c-1.66,0-3,1.34-3,3
		C80.27,102.23,81.61,103.57,83.27,103.57z"
        />
        <path
          fill={color}
          d="M83.27,104.57c-1.84,0-3.56,0.5-5.03,1.37c-0.61,0.35-0.97,1.02-0.97,1.72v6.28h12v-6.28
		c0-0.7-0.36-1.36-0.97-1.72C86.83,105.07,85.11,104.57,83.27,104.57z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M35.09,135.66v-5.87h-3v7.22l-0.09-0.06L21.33,152.2c-1.48,2.12-1.65,5.27-0.4,7.66c0.88,1.69,2.31,2.66,3.94,2.66h78.74
		v-3H24.87c-0.64,0-1.07-0.65-1.28-1.04c-0.62-1.19-0.76-3.19,0.2-4.55l10.67-15.25l-0.01-0.01h69.16v-3H35.09z"
        />
        <path
          fill={color}
          d="M49.03,152.79H31.45c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h17.58h37h17.58v-3H86.03H49.03z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M50.79,50.49H22.43c-4.35,0-7.89,3.54-7.89,7.89v59.65c0,4.35,3.54,7.89,7.89,7.89h28.36c4.35,0,7.89-3.54,7.89-7.89V58.38
		C58.68,54.03,55.14,50.49,50.79,50.49z M22.43,53.49h28.36c2.7,0,4.89,2.19,4.89,4.89v2.32H17.54v-2.32
		C17.54,55.69,19.73,53.49,22.43,53.49z M55.68,63.7v47.06H17.54V63.7H55.68z M50.79,122.92H22.43c-2.7,0-4.89-2.19-4.89-4.89v-4.26
		h38.14v4.26C55.68,120.72,53.48,122.92,50.79,122.92z"
        />
        <path
          fill={color}
          d="M41.82,116.98H31.39c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h10.43c0.83,0,1.5-0.67,1.5-1.5S42.65,116.98,41.82,116.98z
		"
        />
      </g>
      <path
        fill={color}
        d="M45.61,74.23v26h-18v-26H45.61 M46.61,71.23h-20c-1.1,0-2,0.9-2,2v28c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2v-28
	C48.61,72.13,47.71,71.23,46.61,71.23L46.61,71.23z"
      />
      <path
        fill={color}
        d="M36.61,86.12c1.66,0,3-1.34,3-3c0-1.66-1.34-3-3-3s-3,1.34-3,3C33.61,84.78,34.95,86.12,36.61,86.12z"
      />
      <path
        fill={color}
        d="M36.61,87.12c-1.84,0-3.56,0.5-5.03,1.37c-0.61,0.35-0.97,1.02-0.97,1.72v6.28h12v-6.28
	c0-0.7-0.36-1.36-0.97-1.72C40.17,87.62,38.45,87.12,36.61,87.12z"
      />
      <g>
        <path
          fill={color}
          d="M161.86,161.89h-42.97c-2.43,0-4.4-1.98-4.4-4.4v-57.02c0-2.43,1.98-4.4,4.4-4.4h42.97c2.43,0,4.4,1.98,4.4,4.4v57.02
		C166.26,159.92,164.29,161.89,161.86,161.89z M118.89,99.07c-0.77,0-1.4,0.63-1.4,1.4v57.02c0,0.77,0.63,1.4,1.4,1.4h42.97
		c0.77,0,1.4-0.63,1.4-1.4v-57.02c0-0.77-0.63-1.4-1.4-1.4H118.89z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M145.55,168.96h-10.43c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5h10.43c0.83,0,1.5,0.67,1.5,1.5
		S146.38,168.96,145.55,168.96z"
        />
      </g>
      <path
        fill={color}
        d="M244.39,127.49h-64.3v3h64.3c0.83,0,1.5-0.67,1.5-1.5S245.22,127.49,244.39,127.49z"
      />
    </svg>
  );
};
